export default __webpack_public_path__ + "static/media/p_2.d91d429c.jpg";